module.exports = __webpack_public_path__ + "static/media/iconSinAccesso.881657a4.svg";


//////////////////
// WEBPACK FOOTER
// ./src/media/assets/iconSinAccesso.svg
// module id = 107
// module chunks = 0